'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
require('react-dates/initialize');
var DatePickerWithDropdownOptions = require('../DatePickerWithDropdownOptions/DatePickerWithDropdownOptions.js');

var DatePickerWithDropDown = function (props) {
    var selectionType = props.selectionType, startDateProp = props.startDateProp, endDateProp = props.endDateProp, reporter = props.reporter, _a = props.allowAllDates, allowAllDates = _a === void 0 ? false : _a, _b = props.allowToday, allowToday = _b === void 0 ? false : _b, title = props.title, startTitle = props.startTitle, endTitle = props.endTitle, _c = props.className, className = _c === void 0 ? '' : _c, _d = props.availableItems, availableItems = _d === void 0 ? [] : _d, hideDateInputs = props.hideDateInputs, disableStartEndDateField = props.disableStartEndDateField;
    var menuItems = ['7', '14', '30', '60', 'lastWeek', 'lastMonth', 'lastYear'];
    if (allowAllDates) {
        menuItems.unshift('allDates');
    }
    if (allowToday) {
        menuItems.unshift('today');
    }
    var selectedItems = {};
    if (availableItems.length > 0) {
        availableItems.forEach(function (type) {
            selectedItems[type] = true;
        });
        menuItems = menuItems.filter(function (item) { return selectedItems[item]; });
    }
    return (React__default.createElement(DatePickerWithDropdownOptions, { availableItems: menuItems, selectionType: selectionType, startDateProp: startDateProp, endDateProp: endDateProp, reporter: reporter, title: title, startTitle: startTitle, endTitle: endTitle, className: className, hideDateInputs: hideDateInputs, StartProps: {
            disableFuture: true,
        }, EndProps: {
            disableFuture: true,
        }, disableStartEndDateField: disableStartEndDateField }));
};

module.exports = DatePickerWithDropDown;
